'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_types$UserEntry(id, created, deleted, account, kind, code, active, email) {
  this.i0 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$L0;
  this.u9 = null;
  this.xy = null;
  this.Ls = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$L0;
  this.Lt = null;
  this.rV = null;
  this.l0 = false;
  this.f1 = null;
  this.i0 = id;
  this.u9 = created;
  this.xy = deleted;
  this.Ls = account;
  this.Lt = kind;
  this.rV = code;
  this.l0 = active;
  this.f1 = email;
}
export { $c_Lpresto_types$UserEntry as $c_Lpresto_types$UserEntry };
$p = $c_Lpresto_types$UserEntry.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_types$UserEntry;
/** @constructor */
function $h_Lpresto_types$UserEntry() {
}
export { $h_Lpresto_types$UserEntry as $h_Lpresto_types$UserEntry };
$h_Lpresto_types$UserEntry.prototype = $p;
$p.x = (function() {
  return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_Product$$anon$1(this);
});
$p.p = (function() {
  var acc = (-889275714);
  acc = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().o(acc, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_T__hashCode__I("UserEntry"));
  var $x_2 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$();
  var $x_1 = acc;
  var t = this.i0;
  acc = $x_2.o($x_1, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().bj(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_RTLong(t.e, t.f)));
  acc = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().o(acc, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().A(this.u9));
  acc = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().o(acc, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().A(this.xy));
  var $x_4 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$();
  var $x_3 = acc;
  var t$1 = this.Ls;
  acc = $x_4.o($x_3, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().bj(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_RTLong(t$1.e, t$1.f)));
  acc = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().o(acc, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().A(this.Lt));
  acc = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().o(acc, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().A(this.rV));
  acc = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().o(acc, (this.l0 ? 1231 : 1237));
  acc = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().o(acc, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().A(this.f1));
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().ai(acc, 8);
});
$p.i = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lpresto_types$UserEntry)) {
    if ((this.l0 === x$0.l0)) {
      var this$1 = this.i0;
      var b = x$0.i0;
      var $x_5 = ((this$1.e === b.e) && (this$1.f === b.f));
    } else {
      var $x_5 = false;
    }
    if ($x_5) {
      var x = this.u9;
      var x$2 = x$0.u9;
      var $x_4 = ((x === null) ? (x$2 === null) : x.i(x$2));
    } else {
      var $x_4 = false;
    }
    if ($x_4) {
      var x$3 = this.xy;
      var x$4 = x$0.xy;
      var $x_3 = ((x$3 === null) ? (x$4 === null) : x$3.i(x$4));
    } else {
      var $x_3 = false;
    }
    if ($x_3) {
      var this$2 = this.Ls;
      var b$1 = x$0.Ls;
      var $x_2 = ((this$2.e === b$1.e) && (this$2.f === b$1.f));
    } else {
      var $x_2 = false;
    }
    if ($x_2) {
      var x$5 = this.Lt;
      var x$6 = x$0.Lt;
      var $x_1 = ((x$5 === null) ? (x$6 === null) : x$5.i(x$6));
    } else {
      var $x_1 = false;
    }
    if (($x_1 && (this.rV === x$0.rV))) {
      return (this.f1 === x$0.f1);
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.l = (function() {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_ScalaRunTime$().H(this);
});
$p.r = (function() {
  return 8;
});
$p.s = (function() {
  return "UserEntry";
});
$p.j = (function(n) {
  switch (n) {
    case 0: {
      return this.i0;
      break;
    }
    case 1: {
      return this.u9;
      break;
    }
    case 2: {
      return this.xy;
      break;
    }
    case 3: {
      return this.Ls;
      break;
    }
    case 4: {
      return this.Lt;
      break;
    }
    case 5: {
      return this.rV;
      break;
    }
    case 6: {
      return this.l0;
      break;
    }
    case 7: {
      return this.f1;
      break;
    }
    default: {
      throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$p.jW = (function() {
  return this.i0;
});
function $isArrayOf_Lpresto_types$UserEntry(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.kr)));
}
export { $isArrayOf_Lpresto_types$UserEntry as $isArrayOf_Lpresto_types$UserEntry };
var $d_Lpresto_types$UserEntry = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$UserEntry, "presto.types$UserEntry", ({
  kr: 1,
  aH: 1,
  b: 1,
  c: 1,
  a: 1
}));
export { $d_Lpresto_types$UserEntry as $d_Lpresto_types$UserEntry };
//# sourceMappingURL=presto.types$-User-Entry.js.map
